import {
  SmartComponentPropertyDetails,
  SmartComponentSummaryData,
} from "../smart-components/smart-component-property-details";
import { IComponentLoader } from "../../interfaces/IComponentLoader";

/**
 * This class handle the creation of components classes.
 * It semply behavior logics component creations
 */
export class ComponentAdapterFactory {
  constructor() {}

  /**
   * Create componment adapter by type class and fill inner property by smart component skills
   *
   * @param listSmartComponentSkills List of smart component skills
   * @param type Type of component to create
   * @returns
   */
  public createComponentAdapter<T extends IComponentLoader>(
    listSmartComponentSkills: Array<SmartComponentPropertyDetails>,
    type: new () => T,
    dataSmartComponent: SmartComponentSummaryData = null
  ): T {
    let componentFactory: T = new type();

    componentFactory.fillProperty(listSmartComponentSkills, dataSmartComponent);

    return componentFactory;
  }
}
